var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.color,attrs:{"disabled":_vm.disabled},on:{"click":_vm.callback}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }